import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownload } from '@fortawesome/pro-duotone-svg-icons';

function LeadMetaTile({ tab }) {
  const dispatch = useDispatch();
  const {
    batchUI: {
      agencyId,
      campaignId,
    },
    agencies: { records: agencies },
    campaign: { list: campaigns },
    theme: {
      features: {
        campaigns: campaignsFeature,
        agencies: agencyFeature,
      },
    },
    user: { is_admin: isAdmin },
  } = useSelector(store => store);

  let campaignText = '';
  if (campaignsFeature && isAdmin) campaignText = ' and Campaign';

  return (tab !== 'leads_reassignment') ? (
    <>
      <hr />
      <div className="my-3 font-weight-bold">
        {(agencyFeature && isAdmin) ? (
          `Please select an Agency${campaignText} to associate these ${tab} with`
        ) : null}
      </div>
      <div className="row">
        {(agencyFeature && isAdmin) ? (
          <div className="col">
            <b>Agent Group</b>
            <select
              className="form-select"
              value={agencyId}
              defaultValue={agencyId}
              onChange={(e) => {
                dispatch({ type: 'SET_BATCH_AGENCY', payload: e.target.value });
              }}
            >
              <option value={null} />
              {agencies.map((agency) => <option value={agency.id}>{agency.name}</option>)}
            </select>
          </div>
        ) : null}
        {(campaignsFeature && isAdmin) ? (
          <div className="col">
            <b>Campaign</b>
            <select
              className="form-select"
              value={campaignId}
              defaultValue={campaignId}
              onChange={(e) => {
                dispatch({ type: 'SET_BATCH_CAMPAIGN', payload: e.target.value });
              }}
            >
              <option value={null} />
              {campaigns.map((campaign) => <option value={campaign.id}>{campaign.name}</option>)}
            </select>
          </div>
        ) : null}
      </div>
    </>
  ) : null;
}

function DownloadExampleData({ type, disabled, tab }) {
  const {
    theme: { site, batchLoadExampleLinks = {} },
    auth: { token },
  } = useSelector(store => store);

  let text = 'Download the CSV file then make your edits.';
  let buttonText = `Download ${tab} Data`;

  if (['leads', 'leads_reassignment'].includes(tab)) {
    text = 'Example File Format';
    buttonText = 'Download Example';
  }
  let link = `${process.env.REACT_APP_MMB_API_URL}/api/agent/batch-updates/get-csv/?type=${type}&site=${site}&token=${token}`;
  if (batchLoadExampleLinks[tab]) link = batchLoadExampleLinks[tab];

  return (
    <>
      <div className="my-3 font-weight-bold">
        {text}
      </div>
      <div>
        <a
          href={link}
          className={`btn btn-dark text-capitalize ${disabled ? 'disabled' : ''}`}
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon icon={faCloudDownload} fixedWidth size="lg" className="me-2" />
          {buttonText}
        </a>
      </div>
    </>
  );
}

function TemplateTile() {
  const { tab, ready } = useSelector(store => store.batch);
  const { is_admin: isAdmin } = useSelector(store => store.user);
  const disabled = !ready;
  const type = tab === 'license' ? 'state' : tab;

  return (
    <div className="col-md-4 text-center p-4">
      <div>
        <div
          className={[
            'border border-dark border-lg rounded-circle d-inline-flex text-dark',
            'd-flex justify-content-center align-items-center font-weight-bold font-large',
          ].join(' ')}
          style={{ height: '3rem', width: '3rem' }}
        >
          2
        </div>
      </div>
      <DownloadExampleData type={type} tab={tab} disabled={disabled} />
      {isAdmin ? (
        <LeadMetaTile tab={tab} />
      ) : null}
    </div>
  );
}

export default TemplateTile;
